/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PermissionCategory } from '../models/PermissionCategory';
import { PermissionType } from '../models/PermissionType';

export class Permission {
  'permissionType': PermissionType;
  /**
  * The display name of the permission
  */
  'name': string;
  /**
  * Description of the actions the permission allows.
  */
  'description': string;
  /**
  * Whether the permission can be restricted with access conditions. Relevant when the permission is used in a user role. 
  */
  'allowConditions': boolean;
  'category': PermissionCategory;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "permissionType",
      "baseName": "permissionType",
      "type": "PermissionType",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "allowConditions",
      "baseName": "allowConditions",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "category",
      "baseName": "category",
      "type": "PermissionCategory",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Permission.attributeTypeMap;
  }

  public constructor() {
  }
}



